import React from 'react';
import axios from "../../../containers/api";
import {Colxx, Separator} from "../../../components/common/CustomBootstrap";
import {Badge, Button, Card, CardBody, Modal, ModalBody, ModalFooter, ModalHeader, Row} from "reactstrap";
import {showCatchError} from "../../../helpers/Utils";
import {Table} from "../../../components/table/Table";

class Notifications extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            notifications: [],
            selectedNotification: [],
            modal: false
        };

        console.log(props)
    }

    componentDidMount() {
        this.getNotificationList();
    }

    getNotificationList = () => {
        this.props.showSpinner();
        axios.get('api/DashboardNotificationApi/GetMember48HoursAgoNotifications')
            .then((res) => {
                this.props.hideSpinner();
                this.setState({notifications: res.data});
            })
            .catch((error) => {
                this.props.hideSpinner();
                this.props.showAlert(showCatchError(error), "error");
                console.log(error.response);
            });
    };

    markAsRead = (id) => {
        this.props.showSpinner();
        axios.get('api/DashboardNotificationApi/MarkAsRead?notificationId=' + id)
            .then((res) => {
                this.props.hideSpinner();
                this.props.getUnreadNotificationsCount();
                this.getNotificationList();
            })
            .catch((error) => {
                this.props.hideSpinner();
                this.props.showAlert(showCatchError(error), "error");
                console.log(error.response);
            });
    }

    readAll = () => {
        this.props.showSpinner();
        axios.get('api/DashboardNotificationApi/ReadAllMessages')
            .then((res) => {
                this.props.hideSpinner();
                let items = this.state.notifications;
                items.map((item) => item.notificiation.isRead = true);

                this.setState({notifications: items}, () => {
                        this.props.showAlert("وضعیت تمامی پیام‌ها به خوانده شده تغییر پیدا کرد", "success");
                        this.props.getUnreadNotificationsCount();
                    }
                );
            })
            .catch((error) => {
                this.props.hideSpinner();
                this.props.showAlert(showCatchError(error), "error");
                console.log(error.response);
            });
    }

    closeModal = (modalName) => {
        this.setState({ [modalName]: false });
        this.markAsRead(this.state.selectedNotification.notificiation.dashboardNotificationId);
    };

    render() {
        return (
            <>
                <Row>
                    <Colxx xxs="12">
                        <h3 className="text-dark">پیام‌ها و رخدادها (۴۸ ساعت گذشته)</h3>
                        <Separator className="mb-5" />
                    </Colxx>
                </Row>

                <Row className="mb-3">
                    <Colxx xxs="12">
                        <Card>
                            <CardBody className="d-flex flex-column justify-content-center align-items-center">
                                <div className="d-flex flex-md-row flex-column w-100 justify-content-center mt-4">
                                    <Button color="primary" className="mx-3 my-md-0 my-1" onClick={() => this.readAll()}>
                                        خوانده شده
                                    </Button>
                                </div>

                                <Table
                                    tableHeaders={[
                                        "تاریخ",
                                        "نوع",
                                        "موضوع",
                                        "نمایش",
                                    ]}

                                    tableRow={this.state.notifications}

                                    tableData={[
                                        notification => {
                                            return (
                                                <p className={notification.notificiation.isRead === false ? "text-dark" : "text-muted"}>
                                                    {notification.shamsiDate}
                                                </p>
                                            )
                                        },
                                        notification => {
                                            if (notification.state === 'بحرانی') {
                                                return <Badge color="outline-danger" pill>{notification.state}</Badge>
                                            } else if (notification.state === 'اطلاعاتی') {
                                                return <Badge color="outline-info" pill>{notification.state}</Badge>
                                            } else if (notification.state === 'اخطاری' || notification.state === 'امنیتی') {
                                                return <Badge color="outline-warning" pill>{notification.state}</Badge>
                                            }
                                        },
                                        notification => {
                                            return (
                                                    <p className={notification.notificiation.isRead === false ? "text-dark" : "text-muted"}>
                                                        {notification.notificiation.subject}
                                                    </p>
                                                )
                                        },
                                        notification => {
                                            return (
                                                <Button outline color="primary" className="btn-sm" onClick={() => this.setState({selectedNotification: notification, modal: true})}>
                                                    نمایش
                                                </Button>
                                            )
                                        }
                                    ]}
                                />
                            </CardBody>
                        </Card>
                    </Colxx>
                </Row>

                <Modal isOpen={this.state.modal} size="xlg" toggle={() => this.closeModal("modal")}>
                    <ModalHeader toggle={() => this.closeModal("modal")}>
                        {this.state.selectedNotification.notificiation && this.state.selectedNotification.notificiation.subject}
                    </ModalHeader>
                    <ModalBody className="notification-modal">
                        <div>
                            <p dangerouslySetInnerHTML={{__html: this.state.selectedNotification.notificiation && this.state.selectedNotification.notificiation.message}}/>

                            <div>
                                <Badge color="light" className="my-1 mr-2"> دریافت شده در تاریخ </Badge>
                                {this.state.selectedNotification.shamsiDate}
                            </div>
                            <div>
                                <Badge color="light" className="my-1 mr-2"> نوع </Badge>
                                {this.state.selectedNotification.state}
                            </div>
                        </div>
                    </ModalBody>
                </Modal>
            </>
        )

    }
}

export default Notifications;